import PropTypes from 'prop-types';

import Title from './Title';
import Description from './Description';
import Svg500 from 'assets/svg/500.svg';

export default function _500({ title, description }) {
  return (
    <>
      <img src={Svg500} style={{ height: '40%' }} />
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </>
  );
}

_500.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
